import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCurrentUser } from '../../hooks/graphQLAPI';
import './ProfilePage.scss';

export function ProfilePage() {
  // Skip GraphQL query for now since we're not authenticated
  useCurrentUser({ skip: true });

  // For now, always redirect to login since we don't have OIDC authentication set up
  return <Navigate to="/login" />;
}
